exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rec[data-v-5f061602] {\n    font-weight: bold;\n    font-size: 12px;\n    color: RED;\n    display: block;\n}\n", ""]);

// exports
